'use strict';

module.exports = {
  template: require('./salary-invite-import.html'),
  controller: require('./salary-invite-import.controller'),
  controllerAs: 'vm',

  bindings: {
    round: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-invite/salary-invite-import/index.js
 ** module id = 201
 ** module chunks = 0
 **/